import { RecentiComponent } from "./RecentiComponent.tsx";

export const recenti = () => [
  {
    target: "$ONE_TOOLBAR_CONTENT_RIGHT",
    handler: {
      component: RecentiComponent,
      props: { drawerName: "recentiDrawer" },
    },
  },
];
